<template>
  <nav-bar title="气瓶检测管理" />
  <Content :bottom="0">
    <div class="receiver">{{ roleName }}</div>
    <van-cell-group>
      <van-cell
        v-if="roleId === 'ta'"
        title="检测气瓶录入"
        to="/externalCylinderEntry"
        is-link
      />
      <van-cell
        v-if="roleId === 'tb'"
        title="单元检测任务分配格"
        to="/taskAllocation"
        is-link
      />
      <van-cell
        v-if="roleId === 'tc'"
        title="待检测任务列表"
        to="/detection"
        is-link
      />
      <!-- <van-cell title="气瓶检验" is-link />
      <van-cell title="检验审核" is-link /> -->
    </van-cell-group>
  </Content>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
const store = useStore()
const roleName = computed(() => store.state.roleInfo.roleName)
const roleId = computed(() => store.state.roleInfo.roleId)
</script>

<style lang="scss" scoped>
.receiver {
  font-size: 14px;
  padding: 16px;
  background-color: #fff;
}
</style>
